import { AppIcons, Avatar, AvatarFallback } from '@web/ui/core/atoms';

interface CustomerAvatarProps {
  /** Customer display name — drives the fallback initials. */
  name: string;
  /** Renders the VIP crown badge + tint when true. */
  vip: boolean;
  /** Avatar size; defaults to `md`. */
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

/**
 * Customer avatar with the VIP crown overlay. Shared by the card drawer
 * header and the identity tab so the VIP marker reads identically.
 */
export function CustomerAvatar({
  name,
  vip,
  size = 'md',
}: Readonly<CustomerAvatarProps>): React.JSX.Element {
  return (
    <span className="relative inline-flex">
      <Avatar size={size} tone={vip ? 'vip' : 'neutral'}>
        <AvatarFallback displayName={name} />
      </Avatar>
      {vip ? (
        <span
          aria-hidden
          className="absolute -bottom-0.5 -right-0.5 inline-flex h-3.5 w-3.5 items-center justify-center rounded-pill bg-vip-tint text-vip-ink ring-2 ring-surface"
        >
          <AppIcons name="crown" size={8} />
        </span>
      ) : null}
    </span>
  );
}
